var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('img',{staticClass:"img-fluid w-100",staticStyle:{"max-width":"800px"},attrs:{"src":require("../assets/img/pausa.jpg"),"alt":"Fluid-grow image"}})])])
}]

export { render, staticRenderFns }